import type { ComponentProps } from "react";
import type { Reservation } from "@b2bportal/ground-api";
import type { CarCard } from "@tenant/cars";

export const mapCarReservationToCarCardProps = (
  reservation: Reservation
): ComponentProps<typeof CarCard> => {
  return {
    car: {
      baseRate: reservation.baseRate,
      cancellationPolicy: reservation.cancellationRules,
      dropOff: {
        time: reservation.dropOff.dateTime,
        coordinates: reservation.dropOff.location.coordinates,
        address: reservation.dropOff.location.address,
      },
      fees: reservation.fees,
      payAtDesk: reservation.payAtDesk,
      payNow: reservation.payNow,
      pickUp: {
        time: reservation.pickUp.dateTime,
        coordinates: reservation.pickUp.location.coordinates,
        address: reservation.pickUp.location.address,
      },
      supplier: reservation.supplier,
      supplierRef: reservation.supplier.code,
      totalCharge: reservation.totalCharge,
      vehicle: reservation.vehicle,
      vendorRef: reservation.vendor.code,
      hasUnlimitedMileage: false, // not returned in trips api
      requiresCreditCard: false, // not returned in trips api
      opaqueShopRequest: "", // not returned in trips api
    },
  };
};
